import { createAction } from '@ngrx/store';
import { PartieMachineNodeAugmented } from '../reducer/data.reducer';

export const loadData = createAction('[Data] Load', (uid: string) => ({
  uid
}));
export const updateData = createAction('[Data] Update', (pages: PartieMachineNodeAugmented[]) => ({
  pages
}));
export const updateSelectedData = createAction('[Data] Update Selected Data', (selectedPage: any[]) => ({
  selectedPage
}));
export const updateDataVisibility = createAction('[Data] Update Visibility', (selectedPage: {}) => ({
  selectedPage
}));
export const resetData = createAction('[Data] Reset');
